import { render, staticRenderFns } from "./LoadAccesorials.vue?vue&type=template&id=61d3bdae"
import script from "./LoadAccesorials.vue?vue&type=script&lang=js"
export * from "./LoadAccesorials.vue?vue&type=script&lang=js"
import style0 from "./LoadAccesorials.vue?vue&type=style&index=0&id=61d3bdae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports